import { render, staticRenderFns } from "./TopResumePreview.vue?vue&type=template&id=2b249ec0&scoped=true"
import script from "./TopResumePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopResumePreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopResumePreview.vue?vue&type=style&index=0&id=2b249ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b249ec0",
  null
  
)

export default component.exports